import template from './index.pug'
import CallStatusMappingForm from '../components/_form.js'

export default Vue.extend({
  template: template(),
  components: {
    CallStatusMappingForm
  },
  data() {
    return {
      ready: false,
      mappingData: {}
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    t(key) {
      return this.$t(`callStatusMappings.edit.${key}`);
    },

    fetchData() {
      const id = this.$route.params.id;
      
      API.callStatusMappings.show(id).then((response) => {
        this.mappingData = response.data ? response.data : response;
        this.ready = true; 
      }).catch(error => {
        console.error("Error al cargar la codificación:", error);
        this.$notifications.error(this.t('loadError'));
        this.$router.push({ name: 'call-status-mappings-index' });
      });
    }
  }
})